import { render, staticRenderFns } from "./SelectTypeOfImport.vue?vue&type=template&id=b41422ca"
import script from "./SelectTypeOfImport.vue?vue&type=script&lang=js"
export * from "./SelectTypeOfImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports